// Here are the values of keys healed by the localization module when done
// Edit the localize pipe to get the value from the module when done with it
// Edit this key to match the key in localization module

export const defaultLocalizationValues = {
    // buttons
    aumico_button_companies_form_save: 'Save and Continue',
    aumico_button_companies_form_cancel: 'Cancel',

    // validations
    aumico_companies_form_validation_enter_company_name_required: 'Please enter company name',
    aumico_companies_form_validation_enter_company_name_exists: 'Company name already exists',
    aumico_companies_form_validation_email_invalid: 'Invalid email',
    aumico_companies_form_validation_legal_form_required: 'Please select legal form',
    aumico_companies_form_country_has_no_legal_form: "this country doesn't contain your previous selected legal form",

    aumico_companies_form_label_name: 'Name',
    aumico_companies_form_label_street_and_number: 'Street & number',
    aumico_companies_form_label_addition_to_address: 'Addition to address',
    aumico_companies_form_label_zip_code: 'Zip code',
    aumico_companies_form_label_city: 'City',
    aumico_companies_form_label_country: 'Country',
    aumico_companies_form_assigned_users: 'Assigned Users',
    aumico_companies_form_assigned_on: 'Assigned on',

    aumico_admin_organization_list_package_type: 'Type',
    aumico_admin_organization_list_package_start_date: 'Start Date',
    aumico_admin_organization_list_package_end_date: 'End Date',
    aumico_admin_organization_list_package_size: 'Size',
    aumico_admin_organization_list_actions: 'Actions',
    aumico_admin_organization_list_add_package: 'Add Package',
    aumico_admin_organization_list_package_delete: 'Delete',
    aumico_admin_organization_list_package_edit: 'Edit',
    aumico_admin_delete_package_confirmation_dialog_description: 'Are you sure you want to delete this package?',

    aumico_companies_form_label_address: 'Address',
    aumico_companies_form_label_first_name: 'First Name',
    aumico_companies_form_label_last_name: 'Last Name',
    aumico_companies_form_label_email: 'E-Mail',
    aumico_companies_form_label_phone: 'Phone',
    aumico_companies_form_label_uid_number: 'UID number',
    aumico_companies_form_label_legal_form: 'Legal form',

    // placeholders
    aumico_companies_form_placeholder_please_enter: 'Please enter',
    aumico_companies_form_placeholder_please_select: 'Please select',
    aumico_companies_form_placeholder_optional: 'optional',

    // sections
    aumico_companies_form_section_name_contact_details: 'Contact details',
    aumico_companies_form_section_name_legal_information: 'Legal information',

    // notification
    aumico_reports_notification_error_title: 'Error',
    aumico_companies_notification_error_description: 'Something went wrong',

    // companies list table
    aumico_companies_table_label_company_name: 'Company Name',
    aumico_companies_table_label_company_street_and_number: 'Street and Number',
    aumico_companies_table_label_company_postal_code: 'Postal Code',
    aumico_companies_table_label_company_location: 'Location',
    aumico_companies_table_label_company_legal_status: 'Legal Status',

    // zefix integration
    aumico_zefix_search_title: 'Firma in Zefix suchen',
    aumico_zefix_search_subtitle: 'Schweizer Handelsregister · Automatischer Datenimport',
    aumico_zefix_search_placeholder: 'Firmenname oder UID eingeben (z.B. aumico oder CHE-108.814.245)…',
    aumico_zefix_uid_mode: 'UID-Modus',
    aumico_zefix_results_count: '{{count}} Ergebnis(se) im Handelsregister',
    aumico_zefix_no_results_title: 'Keine Einträge in Zefix gefunden',
    aumico_zefix_no_results_reason_1: 'Einzelunternehmen ohne HR-Eintrag',
    aumico_zefix_no_results_reason_2: 'Ausländische Firma',
    aumico_zefix_no_results_reason_3: 'Noch nicht im Handelsregister eingetragen',
    aumico_zefix_no_results_reason_4: 'Tippfehler in Name oder UID',
    aumico_zefix_manual_entry: 'Firma manuell erfassen',
    aumico_zefix_imported_banner: 'aus Zefix importiert — Felder prüfen und speichern.',
    aumico_zefix_save_button: 'Felder prüfen & Speichern',
    aumico_zefix_refresh_button: 'Aktualisieren',
    aumico_zefix_new_search: 'Neue Suche',
    aumico_zefix_badge: '✓ Zefix',
    aumico_zefix_unavailable: 'Zefix ist momentan nicht erreichbar. Bitte Felder manuell eintragen.',
    aumico_zefix_diff_title: 'Zefix Abgleich',
    aumico_zefix_diff_field: 'Feld',
    aumico_zefix_diff_current: 'Aktuell',
    aumico_zefix_diff_new: 'Zefix (neu)',
    aumico_zefix_diff_no_changes: 'Alle Daten sind aktuell — keine Änderungen gefunden.',
    aumico_zefix_diff_apply_all: 'Alle übernehmen',
    aumico_zefix_status_in_liquidation: 'In Liquidation',
    aumico_zefix_status_cancelled: 'Gelöscht',
    aumico_zefix_field_name: 'Firmenname',
    aumico_zefix_field_legalform: 'Rechtsform',
    aumico_zefix_field_street: 'Strasse',
    aumico_zefix_field_zip: 'PLZ',
    aumico_zefix_field_city: 'Ort',
    aumico_zefix_field_uid: 'UID',

    // REV-22155: tag box
    aumico_tags_box_title: 'Tag',
    aumico_tags_box_new_tag_placeholder: 'Create new tag',
    aumico_tags_box_create: 'Create',
    aumico_tags_box_cancel: 'Cancel',
    aumico_tags_box_delete: 'Delete',
    aumico_tags_box_delete_warning: 'is used by {{companies}} companies and {{persons}} persons and will be removed there. Really delete?',
    aumico_tags_box_delete_aria: 'Delete tag',

    // REV-22155: person form
    aumico_persons_form_details_text: 'Person details',
    aumico_persons_form_section_personal: 'Personal details',
    aumico_persons_form_first_name: 'First name',
    aumico_persons_form_last_name: 'Last name',
    aumico_persons_form_assignee: 'Mandate manager',
    aumico_persons_form_clerk: 'Clerk',
    aumico_persons_form_search: 'Search',
    aumico_persons_form_placeholder: 'Please enter',
    aumico_persons_form_section_address: 'Address',
    aumico_persons_form_street: 'Street & number',
    aumico_persons_form_addition_to_address: 'Addition to address',
    aumico_persons_form_zip: 'Zip code',
    aumico_persons_form_city: 'City',
    aumico_persons_form_section_contact: 'Contact details',
    aumico_persons_form_email: 'E-mail',
    aumico_persons_form_phone: 'Phone',
    aumico_persons_form_email_invalid: 'Invalid e-mail address',
    aumico_persons_form_add_contact: 'Add contact',
    aumico_persons_form_remove_contact_aria: 'Remove contact',
    aumico_persons_form_section_companies: 'Linked companies',
    aumico_persons_form_company: 'Company',
    aumico_persons_form_role: 'Role',
    aumico_persons_form_please_choose: 'Please choose',
    aumico_persons_form_link: 'Link',
    aumico_persons_form_unlink_aria: 'Remove link',
    aumico_persons_form_company_deleted: 'Company deleted',
    aumico_persons_form_role_OWNER: 'Owner',
    aumico_persons_form_role_SHAREHOLDER: 'Shareholder',
    aumico_persons_form_role_MANAGING_DIRECTOR: 'Managing director',
    aumico_persons_form_role_BOARD_MEMBER: 'Board member',
    aumico_persons_form_role_OTHER: 'Other',
    aumico_persons_form_save: 'Save',
    aumico_persons_form_delete: 'Delete',
    aumico_persons_form_deactivate: 'Deactivate',
    aumico_persons_form_activate: 'Activate',
    aumico_persons_form_dialog_cancel: 'Cancel',
    aumico_persons_form_clerk_change_dialog_text: "You're changing the clerk for this person. How should existing tasks be reassigned?",
    aumico_persons_form_delete_dialog_title: 'Delete person?',
    aumico_persons_form_delete_dialog_text: 'The person will be deleted permanently. This cannot be undone.',

    // REV-22155: persons overview
    aumico_persons_overview_tab_active: 'Active',
    aumico_persons_overview_tab_inactive: 'Inactive',
    aumico_persons_overview_search: 'Search',
    aumico_persons_overview_filter_assignee: 'Mandate manager',
    aumico_persons_overview_filter_clerk: 'Clerk',
    aumico_persons_overview_filter_tag: 'Tag',
    aumico_persons_overview_export: 'Export XLS',
    aumico_persons_overview_new: 'New person',
    aumico_persons_overview_col_name: 'Name',
    aumico_persons_overview_col_street: 'Street & number',
    aumico_persons_overview_col_zip: 'Zip code',
    aumico_persons_overview_col_city: 'City',
    aumico_persons_overview_col_tag: 'Tag',
    aumico_persons_overview_col_assignee: 'Mandate manager',
    aumico_persons_overview_col_clerk: 'Clerk',
    aumico_persons_overview_empty_text1: 'No persons yet',
    aumico_persons_overview_empty_text2: 'Add the first person with "New person".',
    aumico_persons_overview_bulk_assignee: 'Change mandate manager',
    aumico_persons_overview_bulk_clerk: 'Change clerk',
    aumico_persons_overview_bulk_next_financial_year: 'Create next financial year',
    aumico_persons_overview_bulk_deactivate: 'Deactivate persons',
    aumico_persons_overview_bulk_deactivate_confirm: 'Are you sure you want to deactivate {{count}} persons?',
    aumico_persons_overview_bulk_selected: 'selected',
    aumico_persons_overview_bulk_assignee_title: 'Change mandate manager for {{count}} persons?',
    aumico_persons_overview_bulk_clerk_title: 'Change clerk for {{count}} persons?',
    aumico_persons_overview_cancel: 'Cancel',
    aumico_persons_overview_save: 'Save',
    aumico_persons_overview_please_choose: 'Please choose',
} as const;

type PickTypeOfKey<T> = {
    [P in keyof T]: P;
};

// just getting the value of the key
export const localizationKeys = Object.keys(defaultLocalizationValues).reduce((acc, key) => {
    acc[key] = key;
    return acc;
}, {} as PickTypeOfKey<typeof defaultLocalizationValues>);
